const StablePermission = {
    CLIENTSCANWRITENEWS : "StablePermission.CLIENTSCANWRITENEWS",
    CLIENTSCANREACTTONEWS: "StablePermission.CLIENTSCANREACTTONEWS",
};



export default StablePermission;